{
  "version": 1,
  "asset_id": "259fe43d-3bf7-4298-b217-eed100fb79b2",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/259fe43d-3bf7-4298-b217-eed100fb79b2/hiatal-type-2-v3-1254.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/259fe43d-3bf7-4298-b217-eed100fb79b2/hiatal-type-2-v3-1254.jpg",
  "original_filename": "hiatal-type-2-v3-1254.jpg",
  "size": 291995,
  "content_type": "image/jpeg",
  "created_at": "2026-10-28T19:42:08Z"
}
